var G = Object.create;
var P = Object.defineProperty;
var Q = Object.getOwnPropertyDescriptor;
var L = (t, e) => (e = Symbol[t]) ? e : /* @__PURE__ */ Symbol.for("Symbol." + t), m = (t) => {
  throw TypeError(t);
};
var D = (t, e, n) => e in t ? P(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var w = (t, e) => P(t, "name", { value: e, configurable: !0 });
var q = (t) => [, , , G(t?.[L("metadata")] ?? null)], B = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], v = (t) => t !== void 0 && typeof t != "function" ? m("Function expected") : t, V = (t, e, n, i, r) => ({ kind: B[t], name: e, metadata: i, addInitializer: (s) => n._ ? m("Already initialized") : r.push(v(s || null)) }), U = (t, e) => D(e, L("metadata"), t[3]), Y = (t, e, n, i) => {
  for (var r = 0, s = t[e >> 1], c = s && s.length; r < c; r++) e & 1 ? s[r].call(n) : i = s[r].call(n, i);
  return i;
}, x = (t, e, n, i, r, s) => {
  var c, o, I, h, C, a = e & 7, E = !!(e & 8), u = !!(e & 16), f = a > 3 ? t.length + 1 : a ? E ? 1 : 2 : 0, M = B[a + 5], k = a > 3 && (t[f - 1] = []), z = t[f] || (t[f] = []), d = a && (!u && !E && (r = r.prototype), a < 5 && (a > 3 || !u) && Q(a < 4 ? r : { get [n]() {
    return y(this, s);
  }, set [n](l) {
    return F(this, s, l);
  } }, n));
  a ? u && a < 4 && w(s, (a > 2 ? "set " : a > 1 ? "get " : "") + n) : w(r, n);
  for (var A = i.length - 1; A >= 0; A--)
    h = V(a, n, I = {}, t[3], z), a && (h.static = E, h.private = u, C = h.access = { has: u ? (l) => Z(r, l) : (l) => n in l }, a ^ 3 && (C.get = u ? (l) => (a ^ 1 ? y : K)(l, r, a ^ 4 ? s : d.get) : (l) => l[n]), a > 2 && (C.set = u ? (l, _) => F(l, r, _, a ^ 4 ? s : d.set) : (l, _) => l[n] = _)), o = (0, i[A])(a ? a < 4 ? u ? s : d[M] : a > 4 ? void 0 : { get: d.get, set: d.set } : r, h), I._ = 1, a ^ 4 || o === void 0 ? v(o) && (a > 4 ? k.unshift(o) : a ? u ? s = o : d[M] = o : r = o) : typeof o != "object" || o === null ? m("Object expected") : (v(c = o.get) && (d.get = c), v(c = o.set) && (d.set = c), v(c = o.init) && k.unshift(c));
  return a || U(t, r), d && P(r, n, d), u ? a ^ 4 ? s : d : r;
}, O = (t, e, n) => D(t, typeof e != "symbol" ? e + "" : e, n), g = (t, e, n) => e.has(t) || m("Cannot " + n), Z = (t, e) => Object(e) !== e ? m('Cannot use the "in" operator on this value') : t.has(e), y = (t, e, n) => (g(t, e, "read from private field"), n ? n.call(t) : e.get(t));
var F = (t, e, n, i) => (g(t, e, "write to private field"), i ? i.call(t, n) : e.set(t, n), n), K = (t, e, n) => (g(t, e, "access private method"), n);
import { inject as X } from "vue";
import J, { AxiosHeaders as ee } from "axios";
import { setupCache as te } from "axios-cache-interceptor";
import { instrumentAxiosInstance as ne } from "@ui-kit/instrumentation";
import { defineStore as ie } from "pinia";
class W {
  _httpMethod;
  _path;
  _statusCode;
  _error;
  constructor(e, n) {
    this._httpMethod = e.config?.method?.toLowerCase();
    const { config: i } = e;
    this._path = i ? J.getUri(i) : void 0, this._statusCode = e.response?.status ?? 500, this._error = n;
  }
  get cloudRequestId() {
    return this._error.cloudRequestId;
  }
  get httpMethod() {
    return this._httpMethod;
  }
  get path() {
    return this._path;
  }
  get referenceNumber() {
    return this._error.cloudRequestId;
  }
  get error() {
    return this._error;
  }
  get statusCode() {
    return this._statusCode;
  }
}
class re extends W {
  // Empty
}
var oe = /* @__PURE__ */ ((t) => (t.TRACE = "trace", t.DEBUG = "debug", t.INFO = "info", t.WARN = "warn", t.ERROR = "error", t))(oe || {}), se = /* @__PURE__ */ ((t) => (t.MOBILE = "mobile", t.TABLET = "tablet", t.DESKTOP = "desktop", t.KIOSK = "kiosk", t))(se || {}), ae = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.JOINT = "joint", t.PURCHASER = "purchaser", t))(ae || {}), pe = /* @__PURE__ */ ((t) => (t.LEASE = "lease", t.OWN = "own", t.RENT = "rent", t.PARENTS = "parents", t.NONE = "none", t.OTHER = "other", t))(pe || {});
const ke = [
  "full",
  "prequalify",
  "prescreen"
];
var T = /* @__PURE__ */ ((t) => (t.OPEN = "open", t.APPROVED = "approved", t.DECLINED = "declined", t.ERROR = "error", t.PENDING = "pending", t.PREAPPROVED = "preapproved", t.PREQUALIFIED = "prequalified", t.NOOFFER = "nooffer", t.SUBMITTED = "submitted", t))(T || {});
((t) => {
  function e(n) {
    return n === "prequalified" || n === "preapproved";
  }
  t.isAnyPreApproval = e;
})(T || (T = {}));
var p = /* @__PURE__ */ ((t) => (t.EMAIL = "email", t.PHONE = "phone", t.STREET = "street", t.DOB = "dob", t.INCOME = "income", t.ACCOUNT = "account", t.FOOTER = "footer", t.PRIMARY_ACCEPT = "primary-accept", t.JOINT_ACCEPT = "joint-accept", t.PRIMARY_JOINT_ACCEPT = "primary-joint-accept", t.PRIMARY_SUBMIT_APP = "submit-app", t.JOINT_SUBMIT_APP = "joint-submit-app", t.PRIMARY_JOINT_SUBMIT_APP = "primary-joint-submit-app", t.LOAN_AGREEMENT = "loan-agreement", t.TILA = "tila", t.CREDIT_SCORE_NOTICE = "credit-score-notice", t.ARBITRATION = "arbitration", t.TERMS = "terms", t.TCPA = "tcpa", t.PRIVACY_POLICY = "privacy-policy", t.TERMS_OF_USE = "terms-of-use", t.E_SIGN = "e-sign", t.ELECTRONIC_TRANSACTION_CONSENT = "electronic-transaction-consent", t.PRIMARY_ACCEPT_STATE = "primary-accept-state", t.JOINT_ACCEPT_STATE = "joint-accept-state", t))(p || {}), ce = /* @__PURE__ */ ((t) => (t.DEFAULT = "default", t.INCOME = "income", t.PHONE = "phone", t))(ce || {}), le = /* @__PURE__ */ ((t) => (t.APPLICATION_FORM = "application_form", t.ADDITIONAL_APPLICATION_FORM = "additional_application_form", t.OFFER_PRESENTATION_PREQUAL = "offer_presentation_prequal", t.OFFER_PRESENTATION_FULL = "offer_presentation_full", t.OFFER_SELECTION = "offer_selection", t.SPLIT_DECISION = "split_decision", t.PREQUALIFY_TERMS = "prequalify_terms", t.FULL_TERMS = "full_terms", t.APPROVED = "approved", t.PENDING = "pending", t.DECLINED = "declined", t.ESIGN = "esign", t.ERROR = "error", t))(le || {}), b = /* @__PURE__ */ ((t) => (t.NONE = "none", t.ACCEPT_OFFER = "accept_offer", t.APPLY = "apply", t.PREQUALIFY = "prequalify", t.PRESCREEN = "prescreen", t.COMPLETE_APPLICATION = "complete_application", t.PATCH = "patch", t))(b || {});
((t) => {
  function e(n) {
    return n === "prequalify" || n === "prescreen";
  }
  t.isSoftHit = e;
})(b || (b = {}));
var de = /* @__PURE__ */ ((t) => (t.SALES_ASSOCIATE_APPROVAL = "sales_associate_approval", t))(de || {}), ue = /* @__PURE__ */ ((t) => (t.PENDING = "pending", t.COMPLETED = "completed", t))(ue || {}), he = /* @__PURE__ */ ((t) => (t.APPLICATION = "application", t.SESSION = "session", t.PROVIDER = "provider", t))(he || {}), ve = /* @__PURE__ */ ((t) => (t.DOCUMENT_UPLOAD = "document_upload", t.PHONE_CALL = "phone_call", t))(ve || {}), me = /* @__PURE__ */ ((t) => (t.APPROVE_FUNDING = "approve_funding", t.PRINT_DOCUMENT = "print_document", t.DOWN_PAYMENT = "down_payment", t.DOCUMENT_UPLOAD = "document_upload", t.FRAUD_ALERT = "fraud_alert", t.JOB_INSTALL_CONTRACT = "job_install_contract", t.PROOF_OF_INCOME = "proof_of_income", t.PROOF_OF_OWNERSHIP = "proof_of_ownership", t.PROOF_OF_MORTGAGE = "proof_of_mortgage", t.PHOTO_ID = "photo_id", t))(me || {}), Re = /* @__PURE__ */ ((t) => (t.ERROR = "error", t.SUCCESS = "success", t.UNAUTHENTICATED = "unauthenticated", t))(Re || {}), Ie = /* @__PURE__ */ ((t) => (t.ERROR = "error", t.PENDING = "pending", t.SUCCESS = "success", t.UNAUTHENTICATED = "unauthenticated", t))(Ie || {}), Ce = /* @__PURE__ */ ((t) => (t.PHONE = "phone", t.EMAIL = "email", t))(Ce || {});
const Ee = (t) => {
  const { store: e } = t;
  return (n) => (e.requestEnd(n.config), n.data);
}, j = "X-Request-Id", fe = "X-Web-Session-Id", Ae = "time-zone", _e = (t) => {
  const { requestIdProvider: e, sessionProvider: n, store: i } = t;
  return (r) => {
    i.requestStart(r);
    const s = r.headers ?? new ee();
    r.headers || (r.headers = s);
    const c = n();
    c && s.set(fe, c);
    const o = e();
    return o && s.set(j, o), s.set(
      Ae,
      Intl.DateTimeFormat().resolvedOptions().timeZone
    ), r;
  };
}, Pe = (t) => {
  const { onSessionTimeout: e, store: n } = t;
  return (i) => {
    if (i.config && n.requestEnd(i.config), i.response?.data?.code === "session_invalid" && e(), i.response)
      if (i.response.status === 400) {
        const r = i.response.data;
        throw new re(i, r);
      } else {
        let r = i.response.data;
        throw !r?.cloudRequestId && i.request?.headers && (r = {
          category: "Network",
          code: i.response.status.toString(),
          message: i.response.statusText,
          cloudRequestId: i.request.headers[j],
          source: r
        }), new W(i, r);
      }
    throw i;
  };
};
function Ue(t, e) {
  const n = String(e.name);
  function i(...r) {
    const s = this.config.store;
    return s.activeCall(n, !0), t.call(this, ...r).finally(() => s.activeCall(n, !1));
  }
  return i;
}
class Oe extends Error {
  constructor(e = "Aborted") {
    super(e), this.name = "AbortError";
  }
}
class R extends Promise {
  // Method defination `.abort()`
  abort;
  // Getter to access abort reason
  get abortReason() {
    return this._abortReason;
  }
  // Internal store of abort reason
  _abortReason;
  // Constructor, note we can provide 3 args: resolve, reject, abortSignal
  constructor(e, n) {
    const i = n ?? new AbortController(), r = i.signal, s = (c, o) => {
      r.addEventListener("abort", () => {
        o(new Oe(this.abortReason));
      }), e(c, o, r);
    };
    super(s), this.abort = (c) => {
      this._abortReason = c ?? "Aborted", i.abort();
    };
  }
  // Wrap other Promise instances to AbortablePromise
  static from = (e, n) => e instanceof R ? e : new R((i, r) => {
    e.then(i).catch(r);
  }, n);
}
var H, N;
H = [Ue];
class $ {
  constructor(e) {
    Y(N, 5, this);
    O(this, "config");
    O(this, "client");
    this.config = e;
    const n = J.create({
      baseURL: e.baseUrl ?? ""
    });
    this.client = te(n), ne(this.client), this.client.interceptors.request.use(_e(e)), this.client.interceptors.response.use(
      Ee(e),
      Pe(e)
    );
  }
  get baseUrl() {
    return this.client.defaults.baseURL;
  }
  get sessionId() {
    return this.config.sessionProvider();
  }
  finishFlow(e, n) {
    return this.client.post(
      `/api/v1/flow/finish/${this.enumToPath(e)}`,
      n
    );
  }
  cancelFlow(e) {
    return this.client.post("/api/v1/flow/finish/canceled", e);
  }
  startFlowWithToken(e) {
    return this.client.post(
      `/api/v1/flow/start/tokens/${encodeURIComponent(e)}`
    );
  }
  startFlowWithEntityKey(e, n = {}) {
    return this.client.post(
      `/api/v1/flow/start/entity-keys/${encodeURIComponent(e)}`,
      n
    );
  }
  startFlowWithDefaultEntityKey() {
    return this.client.post("/api/v1/flow/start");
  }
  restartFlow() {
    return this.client.post("/api/v1/flow/restart");
  }
  restoreFlow(e) {
    return this.client.post("/api/v1/flow/restore", e);
  }
  reevaluateCascade(e) {
    return this.client.post("/api/v1/cascade/reevaluate", e);
  }
  startProviderApply(e, n) {
    let i = `/api/v1/apply/start/providers/${encodeURIComponent(e)}`;
    return n && (i += `?mode=${encodeURIComponent(n)}`), this.client.post(i);
  }
  prescreen(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/prescreen`,
      n
    );
  }
  prequalify(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/prequalify`,
      n
    );
  }
  apply(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/apply`,
      n
    );
  }
  patch(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/patch`,
      n
    );
  }
  acceptOffer(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/acceptOffer`,
      n
    );
  }
  submitApplication(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/submit-application`,
      n
    );
  }
  checkApplication(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/check-application`
    );
  }
  checkPrequalifyApplication(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/prequalify/check`
    );
  }
  refreshPrequalifyApplication(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/prequalify/refresh-application`
    );
  }
  createAccount(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/create-account`,
      null
    );
  }
  submitAfterPrequalify(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/submit-application`,
      null
    );
  }
  getPaymentPlans(e, n, i) {
    const r = new AbortController();
    return R.from(
      this.client.post(
        `/api/v1/providers/${encodeURIComponent(e)}/payment/plans`,
        {
          amountCents: n,
          downPaymentAmountCents: i
        },
        {
          signal: r.signal
        }
      ),
      r
    );
  }
  publishPlansPresented(e) {
    return this.client.post(
      "/api/v1/application/events/financing-plans-presented",
      e
    );
  }
  publishFinancingOptionSummaryPresented(e) {
    return this.client.post(
      "/api/v1/application/events/financing-option-summary-presented",
      e
    );
  }
  publishUserOptOutProviderBypass(e) {
    return this.client.post(
      "/api/v1/application/events/provider-bypass/user-opt-out",
      e
    );
  }
  publishSessionPageView(e) {
    return this.client.post(
      "/api/v1/application/events/session/page-view",
      e
    );
  }
  publishCascadeConsent(e) {
    return this.client.post(
      "/api/v1/application/events/cascade/consent",
      e
    );
  }
  selectPaymentPlan(e, n) {
    const i = encodeURIComponent(e), r = encodeURIComponent(n.providerPlanCode);
    return this.client.post(
      `/api/v1/providers/${i}/payment/plans/${r}/select`,
      n
    );
  }
  confirmPaymentPlan(e, n) {
    const i = encodeURIComponent(e), r = encodeURIComponent(n.providerPlanCode);
    return this.client.post(
      `/api/v1/providers/${i}/payment/plans/${r}/confirm-selection`,
      n
    );
  }
  paymentToken(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/payment/token`,
      n
    );
  }
  geIframeUrl(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/iframeUrl`
    );
  }
  getEsignIframeUrl(e, n) {
    let i = `/api/v1/providers/${encodeURIComponent(e)}/application/esign/iframeUrl`;
    return n && (i += `?frameAncestor=${encodeURIComponent(n)}`), this.client.get(i);
  }
  getEsignIframeUrlWithRedirect(e, n) {
    const i = encodeURIComponent(e);
    return this.client.post(
      `/api/v1/providers/${i}/application/esign/iframeUrl`,
      n
    );
  }
  esign(e, n) {
    const i = encodeURIComponent(e);
    return this.client.post(
      `/api/v1/providers/${i}/application/esign`,
      n
    );
  }
  getEsignStatus(e) {
    const n = encodeURIComponent(e);
    return this.client.get(
      `/api/v1/providers/${n}/application/esign/status`,
      { cache: !1 }
    );
  }
  getEsignStatuses(e) {
    const n = encodeURIComponent(e);
    return this.client.get(
      `/api/v1/providers/${n}/application/esign/statuses`,
      { cache: !1 }
    );
  }
  completeApplication(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/complete`
    );
  }
  getTermsHtml(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/disclosures-html`
    );
  }
  getAgreementHtml(e) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/agreement`
    );
  }
  getApplicationDocuments(e, ...n) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/application/documents`,
      {
        params: {
          types: n
        },
        paramsSerializer: {
          indexes: null
        },
        cache: !1
      }
    );
  }
  deliverApplicationDocuments(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/application/documents/deliver`,
      n
    );
  }
  verifyApplicationDocumentsDelivery(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/application/documents/deliver/verify`,
      n
    );
  }
  validateZipCode(e) {
    return this.client.post("/api/v1/validate/zipCode", e);
  }
  validatePhone(e) {
    return this.client.post("/api/v1/validate/phone", e);
  }
  validateApplication(e) {
    return this.client.post("/api/v1/validate", e);
  }
  loadTestCase(e) {
    return this.client.post(
      `/api/v1/test-cases/apply/${encodeURIComponent(e)}`
    );
  }
  loadQuiz(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/quiz`
    );
  }
  answerQuiz(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/answers`,
      n
    );
  }
  sendVerificationCode(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/send-otp`,
      n
    );
  }
  verifyVerificationCode(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/verify-otp`,
      n
    );
  }
  addBankCard(e, n) {
    const i = encodeURIComponent(e);
    return this.client.post(
      `/api/v1/providers/${i}/application/bank-card`,
      n
    );
  }
  addBankAccount(e, n) {
    const i = encodeURIComponent(e);
    return this.client.post(
      `/api/v1/providers/${i}/application/bank-account`,
      n
    );
  }
  getStipulationStatus(e) {
    return this.client.get(
      `/api/v1/stipulations/${encodeURIComponent(e)}/status`,
      { cache: !1 }
    );
  }
  launchSdkApply(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/sdk/launch`,
      n
    );
  }
  postSdkResults(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/sdk/callback`,
      n
    );
  }
  refreshStipulations(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/stipulations/refresh`,
      {
        application: n
      }
    );
  }
  getProviderStipulationStatus(e, n) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/stipulations/${encodeURIComponent(n)}/status`,
      { cache: !1 }
    );
  }
  uploadStipulationDocument(e, n) {
    const i = new FormData();
    return i.append("stipulationId", n.stipulationId), i.append("document", n.document), this.client.postForm(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/stipulations/${encodeURIComponent(
        n.stipulationId
      )}/document`,
      i,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    );
  }
  getMerchantDisclaimerResponse(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/merchant-product`
    );
  }
  launchExternalApplication(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/apply/launch`,
      n
    );
  }
  processExternalApplicationResult(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/apply/return`,
      n
    );
  }
  async getDisclosures(e, n) {
    let i = n;
    switch (i) {
      case p.PRIMARY_SUBMIT_APP:
      case p.JOINT_SUBMIT_APP:
      case p.PRIMARY_JOINT_SUBMIT_APP:
        i = "submit-app";
        break;
    }
    let s = `/api/v1/providers/${encodeURIComponent(e)}/disclosures`;
    if (i) {
      const o = encodeURIComponent(i);
      s += `/${o}`;
    }
    const c = await this.client.get(s);
    return c.disclosures.forEach((o) => {
      switch (o.type) {
        case "installmentAccountOpeningDisclosure":
          o.type = p.ACCOUNT;
          break;
        case "dateOfBirthDisclosure":
          o.type = p.DOB;
          break;
        case "disclosureAcceptApp":
          o.type = p.PRIMARY_ACCEPT;
          break;
        case "disclosureAcceptCoapp":
          o.type = p.JOINT_ACCEPT;
          break;
        case "disclosureAcceptAppCoapp":
          o.type = p.PRIMARY_JOINT_ACCEPT;
          break;
        case "emailDisclosureRequired":
          o.type = p.EMAIL;
          break;
        case "grossIncomeDisclosure":
          o.type = p.INCOME;
          break;
        case "mainFooter":
          o.type = p.FOOTER;
          break;
        case "phoneDisclosure":
          o.type = p.PHONE;
          break;
        case "streetAddressDisclosure":
          o.type = p.STREET;
          break;
        case "submitApp":
          o.type = p.PRIMARY_SUBMIT_APP;
          break;
        case "submitCoapp":
          o.type = p.JOINT_SUBMIT_APP;
          break;
        case "submitAppCoapp":
          o.type = p.PRIMARY_JOINT_SUBMIT_APP;
          break;
        case "stateDisclosureAcceptApp":
          o.type = p.PRIMARY_ACCEPT_STATE;
          break;
        case "stateDisclosureAcceptCoapp":
          o.type = p.JOINT_ACCEPT_STATE;
          break;
      }
    }), c;
  }
  log(e) {
    return this.client.post("/api/v1/log", e);
  }
  getPurchaseDetails(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/purchase-details`
    );
  }
  publishSessionErrorEvent(e) {
    return this.client.post(
      "/api/v1/application/events/session-error",
      e
    );
  }
  validateBankCard(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/bank-card/validate`,
      n
    );
  }
  rollbackLoan(e) {
    return this.client.delete(
      `/api/v1/providers/${encodeURIComponent(e)}/application/loan`
    );
  }
  getDomainCategories(e) {
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/domain/categories`
    );
  }
  checkUserExists(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/user/exists`,
      n
    );
  }
  providerUserLogin(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/user/login`,
      n
    );
  }
  sendProviderUserPasscode(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(
        e
      )}/application/user/send-passcode`,
      n
    );
  }
  getFields(e) {
    return this.client.get("/api/v1/fields", {
      cache: !1,
      params: {
        providerKeys: e
      },
      paramsSerializer: {
        indexes: null
      }
    });
  }
  getInvalidFields(e) {
    return this.client.get("/api/v1/fields/invalid", {
      cache: !1,
      params: {
        providerKeys: e
      },
      paramsSerializer: {
        indexes: null
      }
    });
  }
  launchApplicationFromQrCode(e) {
    return this.client.post("/api/v1/application/launch/qr", e);
  }
  launchFromMobileDevice(e) {
    return this.client.post("/api/v1/application/launch/mobile", e);
  }
  //<editor-fold desc="Prove">
  proveSendSms(e) {
    return this.client.post(
      "/api/v1/identity-verification/prove/send-sms",
      e
    );
  }
  proveResendSms() {
    return this.client.post("/api/v1/identity-verification/prove/resend-sms");
  }
  getProveSmsStatus() {
    return this.client.get("/api/v1/identity-verification/prove/sms-status", {
      cache: !1,
      vca: {
        trackState: !1
      }
    });
  }
  getProveVerificationResult(e) {
    return this.client.get(
      "/api/v1/identity-verification/prove/verification-result",
      {
        params: {
          provider: e
        },
        cache: !1,
        vca: {
          trackState: !1
        }
      }
    );
  }
  //</editor-fold>
  //<editor-fold desc="Recaptcha">
  startRecaptchaVerification() {
    return this.client.post("/api/v1/recaptcha/start");
  }
  getRecaptchaVerificationResult(e) {
    return this.client.post("/api/v1/recaptcha/verification-result", e);
  }
  //</editor-fold>
  //<editor-fold desc="Receipts">
  generateReceipt(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/generate-receipt`,
      n,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf"
        }
      }
    );
  }
  //</editor-fold>
  //<editor-fold desc="Waterfall">
  getWaterfallResumeStatus(e) {
    return this.client.get(
      `/api/v1/waterfall/${encodeURIComponent(e)}/resume-status`,
      { cache: !1 }
    );
  }
  //</editor-fold>
  //<editor-fold desc="Metadata">
  getZipCodeMetadata(e) {
    return this.client.get("/api/v1/metadata/zip-code", {
      params: {
        zipCode: e
      }
    });
  }
  //</editor-fold>
  //<editor-fold desc="Account Lookup">
  accountLookup(e, n) {
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/account/lookup`,
      n
    );
  }
  //</editor-fold>
  //<editor-fold desc="Offer Lookup">
  offerLookup(e) {
    return this.client.post("/api/v1/application/lookup/resume", e);
  }
  //</editor-fold>
  //<editor-fold desc="Synchrony">
  getSynchronyMpqDeliveryDetails(e) {
    if (!e.startsWith("synchrony"))
      throw new Error(
        `This endpoint is only compatible with synchrony, ${e} cannot use this endpoint`
      );
    return this.client.get(
      `/api/v1/providers/${encodeURIComponent(e)}/apply/mpq/delivery-details`
    );
  }
  deliverSynchronyMpqApplicationUrl(e, n) {
    if (!e.startsWith("synchrony"))
      throw new Error(
        `This endpoint is only compatible with synchrony, ${e} cannot use this endpoint`
      );
    return this.client.post(
      `/api/v1/providers/${encodeURIComponent(e)}/apply/mpq/deliver-application-link/${encodeURIComponent(n)}`
    );
  }
  //</editor-fold>
  // can't use enumToPath from sdk because it would create a circular dependency
  enumToPath(e) {
    return e.toLowerCase().replace("_", "-");
  }
}
N = q(null), x(N, 1, "getPaymentPlans", H, $), U(N, $);
const ge = ie("ApiState", {
  state: () => ({
    environment: "prod",
    inFlight: 0,
    activeCalls: {}
  }),
  getters: {
    callInProgress: (t) => t.inFlight > 0,
    isCallActive: (t) => (e) => !!t.activeCalls[e]
  },
  actions: {
    requestStart(t) {
      t.vca?.trackState !== !1 && (this.inFlight += 1);
    },
    requestEnd(t) {
      t.vca?.trackState !== !1 && (this.inFlight -= 1);
    },
    activeCall(t, e) {
      this.activeCalls[t] = e;
    }
  }
}), S = /* @__PURE__ */ Symbol("omni-apply-client"), we = (t) => t.config.globalProperties.$omniApply, ye = () => {
  const t = X(S);
  if (t)
    return t;
  throw new Error("Failed to inject: " + S.toString());
}, Fe = {
  install(t, e) {
    const n = new $({
      ...e,
      store: ge()
    });
    return t.config.globalProperties.$omniApply = n, t.provide(S, n), n;
  }
};
export {
  Oe as AbortError,
  R as AbortablePromise,
  W as ApiException,
  ce as AppFieldGroupCategory,
  ae as ApplicantType,
  ke as ApplyModes,
  T as ApplyResponseCode,
  re as BadRequestException,
  se as DeviceType,
  p as DisclosureType,
  j as HEADER_REQUEST_ID,
  fe as HEADER_SESSION_ID,
  Ae as HEADER_TIME_ZONE,
  pe as HousingStatus,
  oe as LogLevel,
  $ as OmniApplyApiClient,
  S as OmniApplyApiClientKey,
  Fe as OmniApplyClientPlugin,
  b as ProviderApplyOperation,
  me as ProviderStipulationType,
  le as ScreenId,
  Re as SendVerificationCodeStatus,
  de as SessionStipulationType,
  ve as StipulationResolutionStrategy,
  he as StipulationScope,
  ue as StipulationStatus,
  Ce as VerificationDeliveryMethod,
  Ie as VerifyCodeStatus,
  we as getOmniApplyClient,
  ye as useOmniApplyApiClient,
  ge as useOmniApplyApiState
};
//# sourceMappingURL=index.es.js.map
